/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { ISummaryBoxProps } from './types';

const SummaryBox: React.FC<ISummaryBoxProps> = ({
  title,
  mainData,
  mark,
  mainDataColor,
  active,
  onClick,
  clasName,
}) => (
  <div onClick={onClick} className={`summary-box ${active ? 'active' : ''} ${clasName || ''}`}>
    {mark && (
      <div className='mark' style={{ color: mainDataColor }}>
        {mark}
      </div>
    )}
    <div className='summary-box-main-content'>
      <div className='main-data' style={{ color: mainDataColor }}>
        {mainData}
      </div>
      <div className='title'>{title}</div>
    </div>
  </div>
);

export default React.memo(SummaryBox);
